import React from "react";
import "./mainHeaderSkeleton.scss";

/**
 * Skeleton loader for MainHeader component
 * Maintains the same structure and dimensions as the actual MainHeader
 */
const MainHeaderSkeleton = () => {
  return (
    <header id='page-topbar' className='position-fixed top-0 right-0 header-skeleton'>
      <div className='navbar-header d-flex justify-content-between align-items-center'>
        <div className='d-flex align-items-center'>
          {/* Company logo and name skeleton */}
          <div className='skeleton-company-info skeleton-shimmer'>
            <div className='skeleton-company-logo'></div>
            <div className='skeleton-company-name'></div>
          </div>
        </div>
        <div className='d-flex align-items-center'>
          {/* Right side icons skeleton */}
          {[1, 2, 3, 4, 5].map((item) => (
            <div key={item} className='skeleton-header-icon skeleton-shimmer'></div>
          ))}
          {/* User profile skeleton */}
          <div className='skeleton-user-profile skeleton-shimmer'></div>
        </div>
      </div>
    </header>
  );
};

export default MainHeaderSkeleton;
